import { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"




/* Widget Preloader */
class Preloader extends Component {

    render = () => {

        const { url } = this.props

        const gameImg = url ? url : "https://cb.cuba-lv.com/images/table-images/game-1768978738541-back.jpeg"//`${env.mediapoint}/images/back-casino.webp`

        return (
            <div className="preloader">
                <Picture className="full-image" src={gameImg} alt="Background" />
                <div className="preloader-logo">
                    <div className="bj-logo">
                        <svg viewBox="0 0 120 60" className="bj-logo-crown" aria-hidden="true">
                            <path d="M10 50 L4 16 L30 34 L60 6 L90 34 L116 16 L110 50 Z" fill="url(#bjGold)" stroke="#7a5610" strokeWidth="2" strokeLinejoin="round" />
                            <circle cx="60" cy="6" r="5" fill="url(#bjGold)" stroke="#7a5610" strokeWidth="2" />
                            <circle cx="4" cy="16" r="4" fill="url(#bjGold)" stroke="#7a5610" strokeWidth="2" />
                            <circle cx="116" cy="16" r="4" fill="url(#bjGold)" stroke="#7a5610" strokeWidth="2" />
                            <rect x="10" y="49" width="100" height="7" rx="2" fill="url(#bjGold)" stroke="#7a5610" strokeWidth="2" />
                            <defs>
                                <linearGradient id="bjGold" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0" stopColor="#fbe7a1" />
                                    <stop offset="0.5" stopColor="#e6b53c" />
                                    <stop offset="1" stopColor="#a9791a" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <div className="bj-logo-one">ONE</div>
                        <div className="bj-logo-name">BLACKJACK</div>
                        <div className="bj-logo-live">LIVE</div>
                    </div>
                </div>
                <div className="preloader-indicator">
                    <Picture className="line" src={`${env.mediapoint}/images/preloader/preloader.svg`} alt="Preloader" />
                    <Picture className="star" src={`${env.mediapoint}/images/preloader/star.svg`} alt="Preloader" />
                </div>
                <p className="support">При поддержке</p>
                <Picture className="cubago" src={`${env.mediapoint}/images/cubago.png`} alt="Preloader" />
            </div>
        )
    }

}

export default Preloader